import { FRAYZE_ADDRESS, FRAYZE_EMAIL, FRAYZE_OPENING_HOURS, FRAYZE_SOCIAL_LINKS, FRAYZE_TELEPHONE } from './business-schema';

export interface LocalBusinessSchemaProps {
    name: string;
    description: string;
    url: string;
    areaServed: {
        name: string;
        containedIn: string;
    };
    image?: string[];
    telephone?: string;
    email?: string;
    priceRange?: string;
    address?: {
        streetAddress: string;
        addressLocality: string;
        addressRegion: string;
        postalCode: string;
        addressCountry: string;
    };
    sameAs?: string[];
    serviceType?: string[];
}

export function generateLocalBusinessSchema({
    name,
    description,
    url,
    areaServed,
    image = [
        "https://frayze.ca/assets/denis-mahoney.webp",
        "https://frayze.ca/assets/parth-bhanushali.webp"
    ],
    telephone = FRAYZE_TELEPHONE,
    email = FRAYZE_EMAIL,
    priceRange = "$$",
    address = FRAYZE_ADDRESS,
    sameAs = FRAYZE_SOCIAL_LINKS,
    serviceType
}: LocalBusinessSchemaProps) {
    return {
        "@context": "https://schema.org",
        "@type": "ProfessionalService",
        "@id": "https://frayze.ca/#organization",
        "name": name,
        "description": description,
        "url": url,
        "areaServed": {
            "@type": "City",
            "name": areaServed.name,
            "containedIn": {
                "@type": "AdministrativeArea",
                "name": areaServed.containedIn
            }
        },
        "address": {
            "@type": "PostalAddress",
            ...address
        },
        "openingHoursSpecification": FRAYZE_OPENING_HOURS,
        "telephone": telephone,
        "email": email,
        "priceRange": priceRange,
        "image": image,
        ...(serviceType && { "serviceType": serviceType }),
        ...(sameAs && { "sameAs": sameAs })
    };
}
